import {
  apiClient,
} from "./apiClient";

import type {
  CreateSupplierInput,
  CreateSupplierResult,
  DeleteSupplierResult,
  SupplierDetailsResult,
  SuppliersPageResult,
  SuppliersQuery,
  UpdateSupplierInput,
  UpdateSupplierResult,
} from "../types/suppliers.types";


/* =========================================================
 * Query String
 * ======================================================= */

function buildQueryString(
  query: SuppliersQuery = {},
): string {
  const params =
    new URLSearchParams();


  if (query.search) {
    params.set(
      "search",
      query.search,
    );
  }


  if (query.type) {
    params.set(
      "type",
      query.type,
    );
  }


  if (query.province) {
    params.set(
      "province",
      query.province,
    );
  }


  if (query.country) {
    params.set(
      "country",
      query.country,
    );
  }


  if (query.currencyCode) {
    params.set(
      "currencyCode",
      query.currencyCode,
    );
  }


  if (
    query.isActive !==
    undefined
  ) {
    params.set(
      "isActive",
      String(
        query.isActive,
      ),
    );
  }


  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }


  if (query.cursor) {
    params.set(
      "cursor",
      query.cursor,
    );
  }


  if (
    query.limit !==
    undefined
  ) {
    params.set(
      "limit",
      String(
        query.limit,
      ),
    );
  }


  const queryString =
    params.toString();


  return queryString
    ? `?${queryString}`
    : "";
}


/* =========================================================
 * Suppliers API
 * ======================================================= */

export const suppliersApi = {

  /**
   * GET /suppliers
   */
  async list(
    query: SuppliersQuery = {},
  ): Promise<SuppliersPageResult> {
    return apiClient.get<
      SuppliersPageResult
    >(
      `/suppliers${buildQueryString(
        query,
      )}`,
    );
  },


  /**
   * GET /suppliers/:id
   */
  async getById(
    supplierId: string,
  ): Promise<SupplierDetailsResult> {
    return apiClient.get<
      SupplierDetailsResult
    >(
      `/suppliers/${encodeURIComponent(
        supplierId,
      )}`,
    );
  },


  /**
   * POST /suppliers
   */
  async create(
    input: CreateSupplierInput,
  ): Promise<CreateSupplierResult> {
    return apiClient.post<
      CreateSupplierResult
    >(
      "/suppliers",
      input,
    );
  },


  /**
   * PATCH /suppliers/:id
   */
  async update(
    supplierId: string,
    input: UpdateSupplierInput,
  ): Promise<UpdateSupplierResult> {
    return apiClient.patch<
      UpdateSupplierResult
    >(
      `/suppliers/${encodeURIComponent(
        supplierId,
      )}`,
      input,
    );
  },


  /**
   * DELETE /suppliers/:id
   */
  async remove(
    supplierId: string,
  ): Promise<DeleteSupplierResult> {
    return apiClient.delete<
      DeleteSupplierResult
    >(
      `/suppliers/${encodeURIComponent(
        supplierId,
      )}`,
    );
  },
};